var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.swapedBtnToLink ? 'nuxt-link' : 'a-button',{tag:"component",staticClass:"show-more-btn",attrs:{"to":_vm.to,"loading":_vm.loading},on:{"click":_vm.addMore}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }